import { gql } from "@apollo/client";

export default gql`
  mutation updateTopicTitleDescriptionMutation(
    $topicId: Int!
    $title: String
    $description: String
    $meetingId: Int
  ) {
    createOrUpdateTopic(
      topicId: $topicId
      title: $title
      description: $description
      meetingId: $meetingId
    ) {
      topic {
        id
        title
        description
      }
    }
  }
`;
